// Shared reference shape for a person tagged in a memory or collection.
// Used by the ParticipantPicker and its callers (capture flow, memory detail,
// collection setup) to express three kinds of taggable people in one array.
//
// Caller is responsible for translating ParticipantRef[] into DB rows:
//   - owner / connection (with profileId) → memory_participants.profile_id
//   - connection (no profileId) / name    → memory_participants.participant_name
//   - for collections, ME is suppressed entirely (owner is implicit) and
//     connection refs flatten to collections.participant_member_ids.

export type ParticipantRef =
  | {
      kind: "owner";
      profileId: string;
    }
  | {
      kind: "connection";
      connectionId: string;
      profileId: string | null;
      role: "member" | "contributor";
      name: string;
    }
  | {
      kind: "name";
      name: string;
    };

/** Stable key used by the picker for keyed render and selection comparison. */
export function participantRefKey(ref: ParticipantRef): string {
  if (ref.kind === "owner") return `owner:${ref.profileId}`;
  if (ref.kind === "connection") return `conn:${ref.connectionId}`;
  return `name:${ref.name.toLowerCase()}`;
}
